import type { IMasterDataRetailerMatchRuleRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataRetailerMatchRuleDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataRetailerMatchRuleUseCase {
  private readonly repository: IMasterDataRetailerMatchRuleRepository;

  constructor(repository: IMasterDataRetailerMatchRuleRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataRetailerMatchRuleDTO) {
    return this.repository.updateMatchRule(params);
  }
}
